export const SingleFeaturedCard = ({
    imageSource,
    title,
    text
})=>{
    return (
        <div className="flex items-start gap-4">
                <img src={imageSource} alt="" />
            <div className="flex-col">
                <h3 className="font-bold text-[1rem] mb-1">{title}</h3>
            <p className="m-0 text-[#9C9C9C] text-[0.9rem]">{text}</p>
            </div>
        </div>
    )
}